import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Link, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  updateAboutUsLastTitle,
  getAboutUsLastTitle,
  createAboutUsLastTitle,
} from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";

// Validation schema
const validationSchema = Yup.object({
  tittle: Yup.string().required("Title is required"),
});

export default function TitleEdit() {
  const {id, partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const navigate = useNavigate();
  const [wordLimitExceeded, setWordLimitExceeded] = useState(false);
  const [header, setHeader] = useState({
    tittle: "",
    index: null,
  });

  const fetchTitleData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const response = await getAboutUsLastTitle(id);
      const headerData = response.data.data[0];
      setHeader({
        ...headerData,
        index: response.data.data.indexOf(headerData),
      });
      console.log(response.data.data[0].tittle);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
   fetchTitleData();
  }, [id]);

  const handleHeaderChange = (event, setFieldValue) => {
    const value = event.target.value;
    setFieldValue("tittle", value);
    
    if (
      value.split(" ").length > 50 ||
      value.length > 80
    ) {
      setWordLimitExceeded(true);
    } else {
      setWordLimitExceeded(false);
    }
  };

  const createTitle = async (values) => {
    setIsUpdating(true);
    if (wordLimitExceeded) return;
    try {
      const formData = {
        tittle: values.tittle, 
        partner_id: partnerId
      };
      const response = await createAboutUsLastTitle(formData);
      if(response.status === 200){
        showToast({
          type: 'success',
          message: 'Bottom section has been created successfully!',
        });
        const bottomData = response?.data?.data;
        setHeader(bottomData);
        if (bottomData && bottomData.id) {
          navigate(`/${partnerId}/aboutus/bottom_title/edit/${bottomData.id}`);
        }
      }else{
        showToast({
          type: 'error',
          message: 'Failed to create bottom section. Please try again.',
        });
        Promise.resolve();
      }
      setIsUpdating(false);
    } catch (error) {
      showToast({
        type: 'error',
        message: 'Failed to create bottom section. Please try again.',
      });
      console.error(error);
      setIsUpdating(false);
    }
  };

  const updateTitle = async (values) => {
    setIsUpdating(true);
    if (wordLimitExceeded) return;
    try {
      const formData = {
        tittle: values.tittle, 
        partner_id: partnerId
      };
      const response = await updateAboutUsLastTitle(id, formData);

      console.log(response.data);
      showToast({
        type: 'success',
        message: 'Bottom section has been updated successfully!',
      });
      setIsUpdating(false);
    } catch (error) {
      showToast({
        type: 'error',
        message: 'Failed to update bottom section. Please try again.',
      });
      console.error(error);
      setIsUpdating(false);
    }
  };

  const handleSubmit = async (values) => {
    if (!Number(id)){
      await createTitle(values);
    }else{
      await updateTitle(values);
    }
  };

  const getInitialValues = () => ({
    tittle: header.tittle || "",
  });

  return (
    <FormWrapper>
      {isLoading ? <CmsCircularProgress/> :  
        <Formik
          initialValues={getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ handleSubmit, getFieldProps, setFieldValue, values, errors, touched }) => (
            <Form onSubmit={handleSubmit} noValidate>
              <Title>{Number(id) ? 'Edit' : 'Add' } Bottom section</Title>
              <SliderDiv>
                <FormGroup 
                  label='Enter a New Title' 
                  requiredField
                  error={
                    (touched.tittle && errors.tittle) || 
                    (wordLimitExceeded ? 'Word limit exceeded.' : '')
                  }
                >
                  <Form.Control
                    type="text"
                    {...getFieldProps("tittle")}
                    onChange={(e) => handleHeaderChange(e, setFieldValue)}
                    isInvalid={
                      (touched.tittle && errors.tittle) || 
                      wordLimitExceeded
                    }
                  />
                </FormGroup>
                
                {/* Button section */}
                <ButtonWrapper className="mt-3">
                  <Link
                    to={`/${partnerId}/aboutus/bottom_title/view/${Number(id) ? id : 'create'}`}
                    style={{
                      width: "50%",
                    }}
                  >
                    <Button variant="secondary">Go Back</Button>
                  </Link>
                  <Button
                    type="submit"
                    style={{
                      width: "50%",
                    }}
                    disabled={isUpdating || wordLimitExceeded}
                  >
                    {isUpdating ? "Saving..." : "Save Changes"}
                  </Button>
                </ButtonWrapper>
              </SliderDiv>
            </Form>
          )}
        </Formik>
      }
    </FormWrapper>
  );
}

const FormWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  gap: 2rem;
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;